import React, { Component } from "react";
import PropTypes from "prop-types";
import { inject, observer } from "mobx-react";
import { GridColumn, GridRow, Input, Label } from "arv-reactcomponents";

import AddressBlock from "../AddressBlock";
import { RETURNS } from "npmlinks-constants";

const { ADDR_NOT_SERVICIBLE } = RETURNS;

@inject("AddressStore", "ReturnStore")
@observer
class AddressBlockWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showMenu: false,
    };
    this.showMenu = this.showMenu.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
  }
  showMenu() {
    this.setState({ showMenu: true });
  }

  closeMenu() {
    setTimeout(() => {
      this.setState({ showMenu: false });
    }, 200);
  }

  render() {
    const {
      address,
      className,
      disabled,
      isDefault,
      onEditClick,
      onRemoveAddress,
      onSelect,
      onSetAddressDefault,
      doNotShowRemoveAddress,
    } = this.props;
    if (disabled) {
      return (
        <GridRow
          className={`nw-addressblockwrapper-addrswrapper is-disabled ${className}`}
        >
          <GridColumn className="nw-addressblockwrapper-notservicible">
            <span className="nw-addressblockwrapper-notservicibletxt">
              {ADDR_NOT_SERVICIBLE}
            </span>
          </GridColumn>
          <GridColumn className="nw-addressblockwrapper-block">
            <AddressBlock.component address={address} showAddressDefault />
          </GridColumn>
        </GridRow>
      );
    }
    return (
      <GridRow className={`nw-addressblockwrapper-addrswrapper ${className}`}>
        <GridColumn className="nw-addressblockwrapper-menuwrapper">
          <Label className="nw-addressblockwrapper-menu">
            <Input
              readonly="true"
              value=""
              placeholder="Enter Text"
              className="nwc-inp-hide"
              onFocus={this.showMenu}
              onBlur={this.closeMenu}
            />
          </Label>
          {this.state.showMenu && (
            <span className="nw-addressblockwrapper-menucontent">
              <dl>
                <dt
                  role="presentation"
                  className="nw-addressblockwrapper-menulist"
                  onClick={() => onEditClick(address)}
                >
                  Edit
                </dt>
                {!isDefault && (
                  <dt
                    role="presentation"
                    className="nw-addressblockwrapper-menulist"
                    onClick={() => onSetAddressDefault(address.id)}
                  >
                    Set as Default
                  </dt>
                )}
                {!doNotShowRemoveAddress && (
                <dt
                  role="presentation"
                  className="nw-addressblockwrapper-menulist"
                  onClick={() => onRemoveAddress(address.id)}
                  >
                    Remove
                  </dt>
                )}
              </dl>
            </span>
          )}
        </GridColumn>
        <GridColumn
          role="presentation"
          onClick={() => onSelect(address.id, address)}
          className="nw-addressblockwrapper-block"
        >
          <AddressBlock.component address={address} showAddressDefault />
        </GridColumn>
      </GridRow>
    );
  }
}

AddressBlockWrapper.defaultProps = {
  address: {},
  className: "",
  disabled: false,
  isDefault: false,
  doNotShowRemoveAddress: false,
};

AddressBlockWrapper.wrappedComponent.propTypes = {
  address: PropTypes.shape({}),
  className: PropTypes.string,
  onEditClick: PropTypes.func.isRequired,
  onRemoveAddress: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  onSetAddressDefault: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  isDefault: PropTypes.bool,
  doNotShowRemoveAddress: PropTypes.bool,
};

const getFinalComponent = component =>
  inject("AddressStore", "ReturnStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: AddressBlockWrapper.wrappedComponent,
  component: AddressBlockWrapper,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/AddressBlockWrapper/index.js